module.exports = __webpack_public_path__ + "img/browser.c1c5eeb0.svg";